module.exports = __webpack_public_path__ + "img/icon_kejxspslt.b72a279f.png";